import React from 'react';

export default function Pagination({ page, setPage, total, pageSize }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (pages === 1) return null;
  const items = [];
  for (let i = 1; i <= pages; i++) items.push(i);
  return (
    <div style={{ display: 'flex', gap: '.4rem', alignItems: 'center', justifyContent: 'flex-end', marginTop: '.5rem' }}>
      <button onClick={() => setPage(p => Math.max(1, p-1))} disabled={page===1} className="btn btn-slate btn-sm">Prev</button>
      {items.map(i => (
        <button key={i} onClick={() => setPage(i)} className={`btn btn-sm ${i===page? 'btn-emerald':'btn-slate'}`}>{i}</button>
      ))}
      <button onClick={() => setPage(p => Math.min(pages, p+1))} disabled={page===pages} className="btn btn-slate btn-sm">Next</button>
    </div>
  );
}
